import { Pipe, PipeTransform } from '@angular/core';
import { NewFormatToOldService } from "libraries/component/address/address.service";
import { IHotel } from "libraries/hotel/models/hotel";

@Pipe({
    name: 'transformHotelName'

})
export class TransformHotelName implements PipeTransform {
    constructor(
        private readonly newFormatToOldService: NewFormatToOldService
    ) {

    }
    public transform(newHotelName : any) : IHotel {
        return this.newFormatToOldService.transformHotelNewFormatToOld(newHotelName);
    }
}
